import React from "react";

import './status-card.scss';

interface StatusCardProps {
    count: number | string
    title: string
}

const StatusCard: React.FC<StatusCardProps> = ({
    count,
    title
}) => {
    return (
        <div className='status-card'>
            {/* <div className="status-card__icon">
                <i className={icon} />
            </div> */}
            <div className="status-card__info">
                <span>{title}</span>
                <h4>{count}</h4>
            </div>
        </div>
    )
};

export default StatusCard;